<template>
  <v-tabs center-active v-model="currentTabInner" class="custom-tabs">
    <v-tabs-slider></v-tabs-slider>
    <v-tab
      v-for="(tab, index) in tabs"
      :data-test-tabs="tab.title"
      :key="index"
    >
      {{ tab.title }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'AppEntityTabs',
  props: {
    currentTab: {
      type: Number,
      default: 0
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentTabInner: {
      get() {
        return this.currentTab;
      },
      set(value) {
        this.$emit('change-tab', value);
      }
    }
  }
};
</script>

<style lang="scss">
.custom-tabs {
  .v-slide-group__prev,
  .v-slide-group__next {
    display: none !important;
  }
}
</style>
